module.exports = __webpack_public_path__ + "static/media/spinner.95eeac79.gif";